import { module } from 'modujs';
import KeenSlider from 'keen-slider'
import { lazyLoadImage } from '../utils/image';

export default class extends module {
    constructor(m) {
        super(m);
        this.type = this.getData('type')
        this.gap = this.getData('gap')
        this.controls = this.getData('controls')
        this.auto = this.getData('autoPlay')
        this.perView = this.getData('perView')
        this.perViewMobile = this.getData('perViewMobile')
        this.thumbnails = this.getData('thumbnails');
        this.focusAt = this.getData('focusAt');
        this.disableInit = this.getData('disableInit');


        let clickEvents = {};
        if( this.controls ) {
          clickEvents = { ...clickEvents, prev: 'previous', next: 'next'};
        }

        if( this.thumbnails ) {
          clickEvents = { ...clickEvents, thumbnail: "thumbnailClick"};
        }

        this.events = {
          click: clickEvents
        }

        this.progress = 0;
    }

    init() {
      //handle breakpoints
      let breakpoints;

      if(this.perViewMobile) {
        breakpoints = {
          "(max-width: 1000px)": {
            slides: { 
              perView: this.perViewMobile,
              origin: this.focusAt !== null ? +this.focusAt : 'center',
              spacing: this.gap || 0
            }
          }
        }
      }

      this.keenInstance = new KeenSlider(this.$('carousel')[0], { 
        loop: true,
        breakpoints: breakpoints || {},
        slides: {
          origin: this.focusAt !== null ? +this.focusAt : 'center',
          perView: this.perView || 2,
          spacing: this.gap || 0
        } 
      });
      this.onSlideChange();
      this.keenInstance.on('slideChanged', this.onSlideChange.bind(this));

      this.addFadeoutToSlides();

      if( this.auto ) {
        this.keenInstance.on('dragStarted', this.killTimer.bind(this));
        this.autoPlay(4000);
      }

      if(!this.disableInit) {
        this.mount();
      }
    }

    mount() {
      this.$('carousel')[0].style.visibility = "visible";
    }

    unmount() {
      this.keenInstance.destroy()
      this.$('carousel')[0].style.visibility = "hidden";
    }
    

    autoPlay(duration) {
      this.calcProgress(duration);
      this.timer = setInterval(() => {
        this.keenInstance.next();
        clearTimeout(this.progressTimer);
        this.progress = 0;
        this.calcProgress(duration);
      }, duration);
    }

    killTimer() {
      clearInterval(this.timer);
      clearTimeout(this.progressTimer);
      this.progress = 0;
      this.autoPlay(4000);
    }

    onSlideChange() {
      this.setActiveSlide();
      this.setScrollProgress();
    }

    setActiveSlide() {

      const index = this.keenInstance.track.details.rel;
      const allSlides = this.keenInstance.slides;
      const activeSlide =  allSlides[index];

      allSlides.forEach((slide) => {
        slide.classList.remove('-active');
      });
      
      if(activeSlide) {
        activeSlide.classList.add('-active');
      }
    }

    setScrollProgress() {
      const scrollbar = this.$('progress-scroll')[0];
      if(scrollbar) {
        const index = this.keenInstance.track.details.rel;
        const totalSlides = this.keenInstance.track.details.slidesLength;
        const percent = (index + 1) / totalSlides;

        scrollbar.style.width = percent * 100 + "%";
      }
    }

    calcProgress(duration) {
      this.progressTimer = setInterval(() => {
        this.progress = this.progress + 20;
        const perc = this.progress / duration;
        this.$('progress')[0].style.width = perc * 100 + "%";
      } , 20)
    }

    thumbnailClick(e) {
      const index = +e.currentTarget.dataset.index;
      this.keenInstance.moveToIdx(index)
    }

    previous() {
      this.keenInstance.prev();

      if(this.auto) {
        this.killTimer()
      }
      
    }

    next() {
      this.keenInstance.next();
      
      if(this.auto) {
        this.killTimer()
      }
    }

    addFadeoutToSlides() {
      this.fadeOuts = [];
      const slides = this.el.querySelectorAll('.keen-slider__slide')

      if(slides) {
        slides.forEach((el) => {
          let fadeOut =  el.animate([
            { opacity: 1 },
            { opacity: 0 },
          ], {
            duration: 200,
            fill: "forwards",
            easing: "ease-in-out",
          });

          fadeOut.pause();

          this.fadeOuts.push(fadeOut);

        })
      }
    }

    runFadeout() {
      return new Promise((resolve, reject) => {
        if(this.fadeOuts) {
          this.fadeOuts.forEach((animation) => {
            animation.play();
            animation.finished.then(() => {
              resolve();
            })
          })
        } else {
          reject()
        }
      })
    }

    async addNewImages(content) {
      await this.runFadeout()

      this.keenInstance.destroy();
      let lazyImages,lazyThumbs;
      if(this.$('carousel')[0]) {
        this.$('carousel')[0].innerHTML = content.images;
        lazyImages = this.$('carousel')[0].querySelectorAll('[data-lazyload]');
      }

      if(this.$('thumbs')[0]) {
        this.$('thumbs')[0].innerHTML = content.thumbs;
        lazyThumbs = this.$('thumbs')[0].querySelectorAll('[data-lazyload]');
      }
      
      this.init();
      //this.call('update', null, 'Scrollmodule');
      if(lazyImages) {
        lazyImages.forEach((el) => {
          lazyLoadImage(el, null, () => {
            //callback
          })
        })
      }

      if(lazyThumbs) {
        lazyThumbs.forEach((el) => {
          lazyLoadImage(el, null, () => {
            //callback
          })
        })
      }
    }

    destroy() {
      if(this.keenInstance) {
        this.keenInstance.destroy();
      } 
    }
}